import { AbstractControl } from '@angular/forms';

export function DatepickerInterval(control: AbstractControl) {
  const fromDate = control.parent.get('fromDate');
  const toDate = control.parent.get('toDate');
  if (fromDate && toDate) {
    return fromDate.invalid || toDate.invalid
      ? { DatepickerInterval: true }
      : undefined;
  }
}
